export default "__VITE_ASSET__J85NXEuh__"